module.exports = __webpack_public_path__ + "img/seme_3kl.5496e61c.jpg";